module.exports = __webpack_public_path__ + "static/media/supportCarousal.6726fcbb.svg";